export default "__VITE_ASSET__b6c52666__"